import { Action, createReducer, on } from '@ngrx/store';

import {
  entityIntegranteAddFailure,
  entityIntegranteAddRequest,
  entityIntegranteAddSuccess,
  entityIntegranteChangeFailure,
  entityIntegranteChangeRequest,
  entityIntegranteChangeSuccess,
  entityIntegranteDeleteFailure,
  entityIntegranteDeleteRequest,
  entityIntegranteDeleteSuccess,
  entityIntegranteLoadFailure,
  entityIntegranteLoadRequest,
  entityIntegranteLoadSuccess
} from './entity-integrante.actions';
import { EntityIntegranteState, entityIntegranteAdapter, initialState } from './entity-integrante.state';

const reducer = createReducer(
  initialState,
  // load
  on(entityIntegranteLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    hasAddedSuccess: false,
    error: null
  })),
  on(entityIntegranteLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityIntegranteLoadSuccess, (state, { items }) =>
    entityIntegranteAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  //add
  on(entityIntegranteAddRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entityIntegranteAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityIntegranteAddSuccess, (state, { item }) => {
    return entityIntegranteAdapter.addOne(item, {
      ...state,
      hasAddedSuccess: true,
      isLoading: false,
      error: null
    });
  }),
  // change
  on(entityIntegranteChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityIntegranteChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityIntegranteChangeSuccess, (state, { item }) =>
    entityIntegranteAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityIntegranteDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityIntegranteDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityIntegranteDeleteSuccess, (state, { item }) =>
    entityIntegranteAdapter.removeOne(item.rol.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function integranteReducer(
  state: EntityIntegranteState | undefined,
  action: Action
) {
  return reducer(state, action);
}
